/* RXLib Config */

import { TipoColunaTabelaBase } from '../rxlib/components/table';
import { usuarioTemPermissao } from '../rxlib/services/seguranca';
import { Item, Menu } from '../rxlib/components/layout/rxlib-Layout';
import { RequestType } from '../rxlib/components/select/select-label-async';

/* SelectLabelAsync */

export const SelectLabelAsyncPrimaryColor = '#FF7D00';
export const SelectLabelAsyncDisabledColor = '#CCCCCC';
export const SelectLabelAsyncSecondaryColor = '#FFFFFF';

export type DataType = 'DadosFixos' | 'Tag' | 'ItemLicenca' | 'Organizacao';

export const RequestTypeArray: RequestType[] = [
    {
        type: 'Tag',
        useOdata: true,
        fieldValue: 'Id',
        fieldLabel: 'Nome',
        fieldValueLowerCase: 'id',
        fieldLabelLowerCase: 'nome',
        url: '/OData/Tag?$filter=contains(toupper(nome),toupper(\'selectedValue\'))',
    },
    {
        useOdata: true,
        fieldValue: 'Id',
        fieldLabel: 'Nome',
        type: 'ItemLicenca',
        fieldValueLowerCase: 'id',
        fieldLabelLowerCase: 'nome',
        url: '/OData/ItemLicenca?$filter=contains(toupper(nome),toupper(\'selectedValue\'))',
    },
    {
        useOdata: true,
        fieldValue: 'Id',
        fieldLabel: 'Nome',
        type: 'Organizacao',
        fieldValueLowerCase: 'id',
        fieldLabelLowerCase: 'nome',
        url: '/OData/Organizacao?$filter=contains(toupper(nome),toupper(\'selectedValue\'))',
    },
];

/* RxlibLayout */

export const NomeEmpresa = 'Naja';
export const UsarSidebarLayout = false;
export const SecretKey = '9a77a34eaa1b4473';
export const UsarSidebarBodyGradient = false;
export const ExibirNomeEmpresaNavbarLayout = false;

function usuarioPodeVerCadastro(token: string): boolean {
    return ((usuarioTemPermissao(token, 'usuario_visualizar')) ||
        (usuarioTemPermissao(token, 'perfil_usuario_visualizar')) ||
        (usuarioTemPermissao(token, 'organizacao_visualizar')) ||
        (usuarioTemPermissao(token, 'itens_licenca_visualizar')) ||
        (usuarioTemPermissao(token, 'tags_visualizar')) ||
        (usuarioTemPermissao(token, 'legenda_origem_visualizar')) ||
        (usuarioTemPermissao(token, 'licenca_base_visualizar')));
}

function usuarioPodeVerMovimentacao(token: string): boolean {
    return ((usuarioTemPermissao(token, 'controle_acesso_visualizar')) ||
        (usuarioTemPermissao(token, 'estatisticas_consulta')) ||
        (usuarioTemPermissao(token, 'licenca_organizacao_consulta')));
}

export function montarMenus(token: string, administrador: boolean): Menu {
    let menus: Menu = {
        items: [],
    };

    if (usuarioPodeVerCadastro(token)) {
        menus.items.push(montarCadastro(token));
    }

    if (usuarioPodeVerMovimentacao(token)) {
        menus.items.push(montarMovimentacao(token));
    }

    return menus;
}

function montarCadastro(token: string): Item {
    let item: Item = {
        nome: 'Cadastros',
        subItens: [],
    }

    if (usuarioTemPermissao(token, 'usuario_visualizar'))
        item.subItens.push({
            nome: 'Usuários',
            link: '/usuario',
        });

    if (usuarioTemPermissao(token, 'perfil_usuario_visualizar'))
        item.subItens.push({
            nome: 'Perfis de usuários',
            link: '/perfil',
        });

    if (usuarioTemPermissao(token, 'organizacao_visualizar'))
        item.subItens.push({
            nome: 'Organizações / unidades',
            link: '/organizacao',
        });

    if (usuarioTemPermissao(token, 'itens_licenca_visualizar'))
        item.subItens.push({
            nome: 'Itens da licença',
            link: '/itemlicenca',
        });

    if (usuarioTemPermissao(token, 'tags_visualizar'))
        item.subItens.push({
            nome: 'Tags',
            link: '/tag',
        });

    if (usuarioTemPermissao(token, 'legenda_origem_visualizar'))
        item.subItens.push({
            nome: 'Legendas origem',
            link: '/legendaorigem',
        });

    if (usuarioTemPermissao(token, 'licenca_base_visualizar'))
        item.subItens.push({
            nome: 'Licenças base',
            link: '/licencabase',
        });

    return item;
}

function montarMovimentacao(token: string): Item {
    let item: Item = {
        nome: 'Movimentações',
        subItens: [],
    }

    if (usuarioTemPermissao(token, 'controle_acesso_visualizar'))
        item.subItens.push({
            nome: 'Controle de acesso',
            link: '/controleacesso',
        });

    if (usuarioTemPermissao(token, 'estatisticas_consulta'))
        item.subItens.push({
            nome: 'Consulta de estatísticas',
            link: '/estatisticas',
        });

    if (usuarioTemPermissao(token, 'resumo_estatisticas_consulta'))
        item.subItens.push({
            nome: 'Consulta do resumo das estatísticas',
            link: '/resumoestatisticas',
        });

    if (usuarioTemPermissao(token, 'licenca_organizacao_consulta'))
        item.subItens.push({
            nome: 'Consulta de licenças da organização',
            link: '/consultalicencaorganizacao',
        });

    return item;
}

/* Table  */

export type TipoColunaTabela = TipoColunaTabelaBase | 'tipoControle' | 'operador';